import axios from "axios";

const peakExportAPI = axios.create({
  baseURL: process.env.VUE_APP_PeakExportService,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate",
    "CDN-Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate"
  },
});
const peakRealTimeAPIForUser = axios.create({
  baseURL: process.env.VUE_APP_PeakRealTimeServiceForUser,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate",
    "CDN-Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate"
  },
});
const peakRealTimeAPI = axios.create({
  baseURL: process.env.VUE_APP_PeakRealTimeService,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate",
    "CDN-Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate"
  },
});
const peakLineFunctionAPI = axios.create({
  baseURL: process.env.VUE_APP_PeakLineFunctionService,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate",
    "CDN-Cache-Control": "no-store, no-cache, max-age=0, must-revalidate, proxy-revalidate"
  },
});
const peakAuthenticationAPI = axios.create({
  baseURL: process.env.VUE_APP_PeakAuthenticationService,
});

export default { peakExportAPI, peakRealTimeAPI, peakRealTimeAPIForUser, peakLineFunctionAPI, peakAuthenticationAPI };
